module.exports = __webpack_public_path__ + "static/media/group-3.3b454ad1.png";